<div class="attr-banner" *ngIf="visible" @fadeInOut [style.bottom.px]="bottomInset">
  <div class="attr-banner-card" (click)="bannerClick.emit()">
    <app-attraction-image class="attr-banner-img" [url]="imageUrl" [alt]="city"></app-attraction-image>
    <div class="attr-banner-text">
      <div class="attr-banner-title">{{ 'attractions.exploreCity' | translate:{ city: city } }}</div>
      <div class="attr-banner-sub best-price" *ngIf="formattedPrice">
        {{ 'attractions.bannerToursFrom' | translate:{ count: count, price: formattedPrice } }}
      </div>
      <div class="attr-banner-sub" *ngIf="!formattedPrice">
        {{ 'attractions.bannerSubtitle' | translate }}
      </div>
    </div>
    <button type="button" class="attr-banner-close" (click)="onDismiss($event)" aria-label="dismiss">
      <app-attr-icon name="close" [size]="14"></app-attr-icon>
    </button>
  </div>
</div>
